import { api } from './api';

export interface AllocationCandidate {
  barristerId: string;
  name: string;
  memberType: string;
  availability: string;
  openMatters: number;
  score: number;
  reasons: string[];
}

export interface AllocationSuggestionsData {
  practiceArea: string | null;
  conflictStatus: string;
  candidates: AllocationCandidate[];
}

export async function fetchAllocationSuggestions(matterId: string): Promise<AllocationSuggestionsData> {
  return (await api.get(`/work-allocation/suggestions/${matterId}`)).data.data as AllocationSuggestionsData;
}
